import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getCourseCurriculumData,
  getTermsData,
  getCurriculumData,
} from "../../../redux/actions/dataAction";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from "../../../constants/CustomDropdown";
import CustomFilter from "../../../constants/CustomFilter";

const Course = (props) => {
  const [filter, setFilter] = useState({
    term: "Select Term",
    curriculum: "Select Curriculum",
  });
  const [filterData, setFilterData] = useState([]);

  useEffect(() => {
    props.getCourseCurriculumData();
    props.getTermsData();
    props.getCurriculumData();
    console.log(props?.course_curriculum?.data);
  }, []);

  const Filter = () => {
    let term_data = CustomFilter(props?.course_curriculum?.data, [
      { value: filter.term, label: "term", initial_value: "Select Term" },
      {
        value: filter.curriculum,
        label: "curriculum",
        initial_value: "Select Curriculum",
      },
    ]);
    setFilterData(term_data);
  };

  useEffect(() => {
    Filter();
  }, [filter, props?.course_curriculum]);

  const columns = [
    { title: "code", field: "code" },
    { title: "domain", field: "domain" },
    { title: "Type of course", field: "type_of_course" },
    { title: "Prerequisite course", field: "prerequisite_course" },
    { title: "Type", field: "type" },
    { title: "Owner", field: "owner" },
    { title: "Title", field: "title" },
    { title: "Acronym", field: "acronym" },
    { title: "Lecture credits", field: "lecture_credits" },
    { title: "Tutor credits", field: "tutor_credits" },
    { title: "Practical_credits", field: "practical_credits" },
    { title: "Total_credits", field: "total_credits" },
    { title: "Total_ISE_and_MSE_weightage", field: "total_ISE_and_MSE_weightage",},
    { title: "Total_ESE_weightage", field: "total_ESE_weightage" },
    { title: "Reviewer_department", field: "reviewer_department" },
    { title: "Course_reviewer", field: "course_reviewer" },
    { title: "Last_date_to_review", field: "last_date_to_review" },
    { title: "Total_course_contact_hours", field: "total_course_contact_hours", },
    { title: "Total_term_work_marks", field: "total_term_work_marks" },
    { title: "Total_mid_term_marks", field: "total_mid_term_marks" },
    { title: "Total_theory_marks", field: "total_theory_marks" },
    { title: "Total_marks", field: "total_marks" },
    { title: "Ese_duration", field: "ese_duration" },
    { title: "Created By", field: "created_by" },
  ];
  const handleChange = (event) => {
    setFilter({ ...filter, [event.target.id]: event.target.value });
  };
  return (
    <div className="customContainer">
      <CustomHeading title="Course" />
      <div className="row">
        <div className="col-md-4">
          <CustomDropdown
            label="Curriculum :"
            data={
              props?.curriculums?.data?.map((cur) => {
                return ({value: cur.name});
              })
            }
            defaultOption={"Select Curriculum"}
            notDefaultOption
            id={"curriculum"}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-4">
          <CustomDropdown
            label="Term :"
            data={
                props?.terms?.data?.map((term) => {
                return ({value: term.name});
              })
            }
            defaultOption={"Select Term"}
            notDefaultOption
            id={"term"}
            onChange={handleChange}
          />
        </div>
      </div>
      <CustomTableWithAll
        data={filterData}
        title={"Course Curriculum"}
        buttonRequired={true}
        buttonLabel="ADD"
        columns={columns}
        api="/api/Course-Curriculum/"
        identify="CourseCurriculum"
      />
    </div>
  );
};

const mapActionWithProps = {
  getCourseCurriculumData,
  getTermsData,
  getCurriculumData,
};

const mapStateWithProps = (state) => ({
  course_curriculum: state.data.course_curriculum,
  terms: state.data.terms,
  curriculums: state.data.curriculums,
});

export default connect(mapStateWithProps, mapActionWithProps)(Course);